class Header {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.header')

    if (!this.section)
      return

    this.passwordButton = this.section.querySelector('.header__loginPassword')
    this.passwordInput  = this.section.querySelector('.header__loginInput[type="password"]')
    this.searchWrapper  = this.section.querySelector('.header__button--search')
    this.searchButton   = this.searchWrapper.querySelector('.header__buttonLink')
    this.searchBox      = this.searchWrapper.querySelector('.header__search')

    return true

  }

  setEvents() {

    window.addEventListener('scroll', () => { this.stickyHeader() })

    if (this.passwordButton != null) {
        this.passwordButton.addEventListener('click', (e) => {

        e.preventDefault()
        this.togglePassword()

        })
    }

    document.addEventListener('click', (e) => {
      this.hideSearch()
    })

    this.searchWrapper.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    this.searchButton.addEventListener('click', (e) => {
      e.preventDefault()
      this.showSearch()
    })

  }

  stickyHeader() {

    const scroll = getCurrentScroll()

    if (scroll > 0)
      this.section.addClass('header--sticky')
    else
      this.section.removeClass('header--sticky')

  }

  togglePassword() {

    if (this.passwordButton.hasClass('header__loginPassword--active')) {

      this.passwordButton.removeClass('header__loginPassword--active')
      this.passwordInput.setAttribute('type', 'password')

    } else {

      this.passwordButton.addClass('header__loginPassword--active')
      this.passwordInput.setAttribute('type', 'text')

    }

  }

  showSearch() {

    this.searchButton.addClass('header__buttonLink--active')
    this.searchBox.addClass('header__search--active')

  }

  hideSearch() {

    this.searchButton.removeClass('header__buttonLink--active')
    this.searchBox.removeClass('header__search--active')

  }

}
